<script setup lang="ts">
  import { ExternalRoute } from "@/constants/externalRoute"
  import { Route } from "@/constants/route"
  import envVariable from "@/lib/shared/envVariable"
  import { useStepWizard } from "@/lib/useStepWizard"
  import { StepWizard } from "@/components/ui/step-wizard"

  const { modelValue } = useStepWizard()

  const showMeterReadingStep = envVariable.isActive(
    "VITE_SHOW_COT_METER_READING",
  )

  const steps = [
    { route: `${Route.moveIn}/${Route.cotMoveInFindAddress}` },
    { route: `${Route.moveIn}/${Route.cotMoveInFdor}` },
    ...(showMeterReadingStep
      ? [{ route: `${Route.moveIn}/${Route.cotMoveInMeterReading}` }]
      : []),
    { route: `${Route.moveIn}/${Route.cotMoveInPersonalDetails}` },
    { route: `${Route.moveIn}/${Route.cotMoveInMonthlyPayment}` },
    { route: `${Route.moveIn}/${Route.cotMoveInPayments}` },
    { route: `${Route.moveIn}/${Route.cotMoveInReview}` },
  ]

  const onLeave = () => {
    window.location.assign(ExternalRoute.websiteHome)
  }
</script>

<template>
  <StepWizard
    :initial-step="modelValue"
    :steps="steps"
    title="Moving Home"
    @leave-page="onLeave"
  >
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </StepWizard>
</template>
